import { Pipe, PipeTransform, NgModule } from '@angular/core';

export enum LinkCategory {
    Normal = 0,Preferred = 1
}

@Pipe({
  name: 'linkCategory'
})
export class LinkCategoryPipe implements PipeTransform {
  transform(value: number): string {
    return (LinkCategory)[value];
  }
}

@NgModule({
  exports: [ LinkCategoryPipe ],
  declarations: [ LinkCategoryPipe ]
})
export class LinkCategoryModule {
}




// WEBPACK FOOTER //
// ./src/app/typewriter/output/LinkCategory.ts